module.exports = __webpack_public_path__ + "assets/img/home-img1.1dabc424.png";